export default __webpack_public_path__ + "static/media/1.d682d8e3.jpg";